import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledGlobalHeader = createGlobalStyle`
  body {
    overflow: auto;
  }
`;

export const StyledGallaryCarouselModal = styled.div`
  .gallary-carousel-modal {
    .custom-scrollbar {
      position: relative;
      margin: 0 auto;
      top: 25%;
      max-width: 100%;
      display: flex;
      justify-content: center;
      @media ${baseVariables.mediaQuery.md} {
        max-width: 80%;
        top: 5%;
      }
      @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
        max-width: 75%;
        top: 5%;
      }
    }
  }

  .modal-gallary-body {
    overflow: visible !important;
    padding: 0 !important;
    width: 100%;
    max-width: 100%;
  }

  .glide__controls_wrapper {
    bottom: ${toRem(16)};
  }
  .gallary-overlay--img {
    max-width: 100%;
    height: auto;
    aspect-ratio: 16/9;
  }

  .popup-close-button {
    position: absolute;
    z-index: 1;
  }
`;
